import { CRMPesoAtividade } from "../enum";
import { CRMTipoAtividade } from "./crmtipo-atividade";

export class CRMAtividade {
    id: number;
    idOportunidade: number;
    idUsuario: number;
    nomeUsuario: string;
    idTipoAtividade: number;
    tipoAtividade: CRMTipoAtividade;
    dataHora: Date;
    dataHoraFim?: Date;
    duracao: number;
    anotacao: string;
    idOrcamento: string;
    status: number;
    dtStatus: Date;
    dtCriacao: Date;
    tipoAtividadeIcone: string;
    tipoAtividadeDescricao: string;
    contatoNome: string;
    idContato: number;
    oportunidadeTitulo: string;
    crmNome: string;
    idUsuarioOportunidade: number;
    checado: boolean;
    peso: CRMPesoAtividade;
    titulo: string;
    descricao: string;
}
